var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":"xs12 sm8 md6"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("批量导入合作用户")])]),_c('v-card-text',{staticStyle:{"height":"300px"}},[_c('l-select-file',{attrs:{"select-type":"dialog"}},[_c('v-btn',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("选择文件")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }